<template>
  <div class="rootDiv">
    <Field label="* 姓名" placeholder="请输入姓名" v-model="user.username"></Field>
    <Field label="性别" placeholder="请选择性别" :readonly=true @focus.native.capture="SexPickerControl"
           v-model="user.sex"></Field>
    <Field label="* 出生日期" placeholder="请选择出生日期" :readonly=true @focus.native.capture="openDatePicker"
           v-model="user.date"></Field>
    <div style="width: 100%;margin-left: 0.5rem;margin-bottom: 1rem">
      <div class="line_top">
      </div>
      <div style="float: left;margin-bottom: 0.5rem;margin-top: 0.5rem;padding-left: 1.5rem">
        <div style="float:left;margin-top: 0.5rem">
          <span>日期类型</span>
        </div>
        <div style="float:left;margin-left: 1.2rem">
          <mt-switch v-model="user.dateType"></mt-switch>
        </div>
        <div style="float:left;margin-left: 1.2rem;margin-top: 0.4rem">
          <span v-if="user.dateType">公历</span>
          <span v-else>农历</span>
        </div>
      </div>
      <div class="line_bottom" style="display:none">
      </div>
    </div>
    <div style="clear:both;">
      <Field label="出生时间" placeholder="请选择出生时间" :readonly=true @focus.native.capture="openTimePicker"
             v-model="user.time"></Field>
    </div>
    <div style="width: 100%;margin-left: 0.5rem;margin-bottom: 1rem">
      <div class="line_top">
      </div>
      <div style="float: left;margin-bottom: 0.5rem;margin-top: 0.5rem;padding-left: 1.5rem">
        <div style="float:left;margin-top: 0.5rem">
          <span>是否去世</span>
        </div>
        <div style="float:left;margin-left: 1.2rem">
          <mt-switch v-model="user.isDead"></mt-switch>
        </div>
        <div style="float:left;margin-left: 1.2rem;margin-top: 0.4rem">
          <span v-if="user.isDead">是</span>
          <span v-else>否</span>
        </div>
      </div>
      <div class="line_bottom" style="display:none">
      </div>
    </div>
    <div style="clear:both;" v-if="user.isDead">
      <Field label="去世日期" placeholder="请选择出生日期" :readonly=true @focus.native.capture="openDeadDatePicker"
             v-model="user.deadDate"></Field>
    </div>
    <div style="clear: both" v-if="!user.isDead"></div>
    <Field label="微信通知" placeholder="请输入需要通知的微信名称" v-model="user.wechatname"></Field>
    <Field label="备注" type="textarea" rows="4" v-model="user.remarks"></Field>
    <div class="line_bottom">
    </div>
    <Button size="large" class="addbutton" @click="ConfirmUpdate">修 改</Button>
    <DatetimePicker
        ref="date_picker"
        type="date"
        :startDate="startDate"
        :endDate="endDate"
        year-format="{value} 年"
        month-format="{value} 月"
        date-format="{value} 日"
        v-model="tempDate" @confirm="DateConfirm">
    </DatetimePicker>
    <DatetimePicker
        ref="dead_picker"
        type="date"
        :startDate="startDate"
        :endDate="endDate"
        year-format="{value} 年"
        month-format="{value} 月"
        date-format="{value} 日"
        v-model="tempDeadDate" @confirm="DeadDateConfirm">
    </DatetimePicker>
    <DatetimePicker
        ref="time_picker"
        type="time"
        hour-format="{value} 时"
        minute-format="{value} 分"
        v-model="tempTime" @confirm="TimeConfirm">
    </DatetimePicker>
    <Popup class="sexpopup"
           v-model="popupVisible"
           position="bottom">
      <div>
        <div class="buttondiv1"><span @click="SexPickerControl">取消</span></div>
        <div class="buttondiv2"><span @click="SexPickerControl">确定</span></div>
      </div>
      <div class="line"></div>
      <div class="pickerdiv">
        <Picker :slots="slots" @change="onValuesChange"></Picker>
      </div>
    </Popup>
  </div>
</template>

<script>
import {Button, DatetimePicker, Field, Picker, Popup, Switch} from 'mint-ui';
//import 'mint-ui/lib/style.css'
import Vue from 'vue'
import {formatdate} from "@/js/DateUtils";

Vue.component(Switch.name, Switch);

export default {
  name: "UpdateBirthday",
  components: {
    DatetimePicker,
    Field,
    Button,
    Picker,
    Popup
  },
  mounted() {
    if (this.$route.query.birth !== undefined && this.$route.query.birth !== null) {
      this.user.id = this.$route.query.birth['iD']
      this.user.username = this.$route.query.birth['name']
      this.user.wechatname = this.$route.query.birth['wechatname']
      this.user.sex = this.$route.query.birth['sex']
      this.user.date = this.$route.query.birth['dateOfBirthDay']
      this.user.time = this.$route.query.birth['timeOfBirth']
      this.user.isInGroup = this.$route.query.birth['isInGroup']
      let dateType = this.$route.query.birth['dateType'] === 'Solar' ? 1 : 0
      this.user.dateType = Boolean(Number(dateType))
      this.user.remarks = this.$route.query.birth['remarks']
      this.user.isDead = this.$route.query.birth['deadDate'] !== null
      this.user.deadDate = this.formatDateString(this.$route.query.birth['deadDate'])
    }
  },
  data() {
    return {
      qznm: null,
      user: {
        id: null,
        username: null,
        wechatname: null,
        sex: null,
        date: null,
        time: null,
        isInGroup: false,
        dateType: true,
        isDead: false,
        deadDate: null,
        remarks: null,
      },
      birthdayModel: {
        CSRQNM: null,
        XM: null,
        WXMC: null,
        XBNM: null,
        CSN: null,
        CSY: null,
        CSR: null,
        CSS: null,
        CSF: null,
        SRLXNM: null,
        BZ: null,
        SFQNSR: null,
        YHNM: null,
        QSSJ: null,
      },
      startDate: new Date("1901-01-01"),
      endDate: new Date(),
      tempDate: new Date("1990-01-01"),
      tempDeadDate: new Date(),
      tempTime: '00:00',
      slots: [
        {
          flex: 1,
          values: ['男', '女'],
          className: 'slot1',
          textAlign: 'center'
        }
      ],
      popupVisible: false,
      updateUrl: '/api/business/updateBirthday',
      token: localStorage.getItem('token'),
      yhnm: localStorage.getItem('yhnm'),
    }
  },
  methods: {
    onValuesChange(picker, values) {
      this.user.sex = values[0]
    },
    SexPickerControl() {
      this.popupVisible = !this.popupVisible
    },
    openDeadDatePicker() {
      if (this.user.deadDate != null)
        this.tempDeadDate = this.user.deadDate
      this.$refs.dead_picker.open();
    },
    openDatePicker() {
      if (this.user.date != null)
        this.tempDate = this.user.date
      this.$refs.date_picker.open();
    },
    openTimePicker() {
      if (this.user.time != null)
        this.tempTime = this.user.time
      this.$refs.time_picker.open();
    },
    ConfirmUpdate() {
      let that = this
      that.birthdayModel.CSRQNM = that.user.id
      that.birthdayModel.XM = that.user.username
      that.birthdayModel.WXMC = that.user.wechatname
      that.birthdayModel.XBNM = that.user.sex
      that.birthdayModel.CSN = that.user.date.split('-')[0]
      that.birthdayModel.CSY = that.user.date.split('-')[1]
      that.birthdayModel.CSR = that.user.date.split('-')[2]
      if (that.user.time != null) {
        that.birthdayModel.CSS = that.user.time.split(':')[0]
        that.birthdayModel.CSF = that.user.time.split(':')[1]
      }
      that.birthdayModel.BZ = that.user.remarks
      that.birthdayModel.YHNM = that.yhnm
      that.birthdayModel.SRLXNM = that.user.dateType
      that.birthdayModel.SFQNSR = that.user.isInGroup
      if (that.user.isDead) {
        that.birthdayModel.QSSJ = that.user.deadDate
      }

      that.$ajax({
        method: 'get',
        url: that.updateUrl,
        params: {json: that.birthdayModel},
        headers: {token: that.token}
      }).then((response) => {
        let result = response.data['result']
        if (!result) {
          that.$messagebox.alert(response.data.message).then(action => {
            if (action === 'confirm') {
              this.$router.go(-1)
            }
          });
        } else
          this.$router.go(-1)
      }).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      });
    },
    formatDateString(time) {
      const date = new Date(time);
      return formatdate(date, 'yyyy-MM-dd');  // 此处可根据自己的需要自定义想要的日期格式
    },
    //更改时间格式
    formatTen(num) {
      return num > 9 ? (num + "") : ("0" + num);
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return year + '-' + this.formatTen(month) + '-' + this.formatTen(day);
    },
    DateConfirm() {
      this.user.date = this.formatDate(this.tempDate)
    },
    DeadDateConfirm() {
      this.user.deadDate = this.formatDate(this.tempDeadDate)
    },
    TimeConfirm() {
      this.user.time = this.tempTime
    }
  }
}
</script>

<style lang="less" scoped>
.rootDiv {
  margin-top: -0.5rem;
  width: 100%;

  .addbutton {
    background: lightseagreen;
  }
}

.sexpopup {
  width: 100%;
  padding-top: 1rem;

  span {
    color: #2986de;
    font-size: 1rem;
  }
}

.buttondiv1 {
  width: 50%;
  float: left;
}

.buttondiv2 {
  width: 50%;
  float: left;
}

.pickerdiv {
  clear: both;
}

.line {
  width: 100%;
  border-top: solid gray 0.5px;
  margin-top: 1.8rem;
}

.line_top {
  width: 100%;
  border-top: solid darkgray 0.5px;
  margin-top: 0;
}

.line_bottom {
  width: 100%;
  border-top: solid darkgray 0.5px;
  margin-top: 3rem;
}
</style>
